import { BaseApi as Base } from '@micromag/data';

class QuizApi extends Base {
    results(id) {
        return this.requestGet(this.route('api.quiz.show', { screen: id }));
    }

    create(data) {
        return this.requestPost(this.route('api.quiz.store'), data);
    }
}

export default QuizApi;
